import { Alert } from "@mui/material";
import React from "react";

export default function AlertStatus({ severity, msg }) {
  return <Alert severity={severity}>{msg}</Alert>;
}
